
<ng-container *ngIf="user">

    <section class="basicbox fondo">
      <header class="headerperfil padtop">
        <div class="icon">
            <div class="wrapicon">
                <img src="/assets/img/cog.svg" alt="">
            </div>
        </div>
        <h3 translate>
           dashboard.perfil.ajustes
        </h3>
      </header>
        <div class="basicbox uploadfile">
        <div class="formgroup">
        <label for="idnombres" translate>dashboard.perfil.ajustesopt.nombres</label>
        <input  id="idnombres" class="form-control" type="text" [(ngModel)]="nombres" id=
        "disabled" disabled>
        </div>
  
        <div class="formgroup">
        <label for="idapellidos" translate>dashboard.perfil.ajustesopt.apellidos</label>
        <input id="idapellidos" class="form-control" type="text" [(ngModel)]="apellidos" id="disabled" disabled>
        </div>
  
        <div class="formgroup">
          <label for="idtelefono" translate>dashboard.perfil.ajustesopt.telefono</label>
          <input id="idtelefono" class="form-control" type="tel" inputmode="tel" placeholder="+34600111222" [(ngModel)]="telefono">
        </div>
  
        <div class="formgroup">
          <label for="idfechanac" translate>dashboard.perfil.ajustesopt.nacimiento</label>
          <input id="idfechanac" class="form-control" type="date" placeholder="{{'dashboard.perfil.ajustesopt.placeholder' | translate}}" [(ngModel)]="fechanac">
        </div>
  
        <div class="formgroup">
          <label for="idpais" translate>dashboard.perfil.ajustesopt.pais</label>
          <select id="idpais" class="form-control" [(ngModel)]="pais">
            <option value="">{{ 'dashboard.perfil.ajustesopt.seleccionaPais' | translate }}</option>
            <option *ngFor="let country of countryOptions" [value]="country.code">{{ country.label }}</option>
          </select>
        </div>
  
        <div class="formgroup">
        <label for="idgenero" translate>dashboard.perfil.ajustesopt.genero</label>
        <input type=text id="idgenero" class="form-control" [(ngModel)]="genero" id="disabled" disabled 
        >
        </div>
        <input id="buttonAjustes" type="submit" value="{{'dashboard.perfil.ajustesopt.guardar' | translate}}" (click)="saveSettings()">
      </div>
    </section>
  </ng-container>
  
  <ng-container *ngIf="alerta || guardado">
    <div class="respuesta" [ngClass]="responseType === 'success' ? 'respuesta-success' : 'respuesta-error'">
      <p >{{saveresponse}}</p>
    </div>
  </ng-container>
